import { render } from "./NewProductsList.vue?vue&type=template&id=27e9e244&scoped=true"
import script from "./NewProductsList.vue?vue&type=script&lang=js"
export * from "./NewProductsList.vue?vue&type=script&lang=js"

import "./NewProductsList.vue?vue&type=style&index=0&id=27e9e244&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e9e244"]])

export default __exports__